import UserPage from '@/pages/admin/UserPage/UserPage.vue'

export default UserPage
